const { default: callApi } = require("helpers/callApi");

export const getAllEarningsDetails = async(id,type)=>{
    return await callApi(`admin_dashboard/get_admin_dashboard_details?type=${type}&id=${id}`)
}